module.exports = __webpack_public_path__ + "static/media/tutorial.a91cae81.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial.gif
// module id = 220
// module chunks = 0